import { Users } from '../shared/collections/users';
import { Customer } from '../shared/models/customer';
import { Department } from '../shared/models/department';
import { Job } from '../shared/models/job';
import { Organisation } from '../shared/models/organisation';
import { Shift } from '../shared/models/shift';
import { Transfer } from '../shared/models/transfer';
import { PoolerUser, User } from '../shared/models/user';
import { getUsersQuery } from './possibleUsersOnJobQuery';

export interface QueryPossibleUsersForJobParams {
  date: string;
  job: Job;
  organisation: Organisation;
  department: Department;
  shifts: Shift[];
  loggedInCustomer: Customer;
  sharedPoolCustomers: Customer[];
  isOwnJob: boolean;
  undecided?: boolean;
  ignoreUserPreferenceDepartmentBlacklist?: boolean;
  jobInPast?: boolean;
  search?: string;
  transferToMe?: Transfer;
}

export function queryPossibleUsersForJob({
  date,
  job,
  organisation,
  department,
  shifts,
  loggedInCustomer,
  sharedPoolCustomers,
  isOwnJob,
  undecided = false,
  ignoreUserPreferenceDepartmentBlacklist = false,
  jobInPast = false,
  search,
  transferToMe,
}: QueryPossibleUsersForJobParams): PoolerUser[] {
  let usersQuery: Mongo.Selector<User> = {};
  if (job.allowExternalInvitees || job.allowExternalInvitees === undefined) {
    usersQuery['$or'] = [
      getUsersQuery(
        date,
        job,
        organisation,
        department,
        loggedInCustomer,
        isOwnJob,
        undecided,
        ignoreUserPreferenceDepartmentBlacklist,
        jobInPast,
        true,
        false,
        shifts,
        search,
        transferToMe,
      ),
      ...sharedPoolCustomers.map((customer) =>
        getUsersQuery(
          date,
          job,
          organisation,
          department,
          customer,
          isOwnJob,
          (customer.sharedPoolAllowUndecidedCustomerIds?.includes(
            loggedInCustomer._id,
          ) &&
            undecided) ||
            false,
          false,
          jobInPast,
          true,
          false,
          shifts,
          search,
          transferToMe,
        ),
      ),
    ];
  } else {
    usersQuery = getUsersQuery(
      date,
      job,
      organisation,
      department,
      loggedInCustomer,
      isOwnJob,
      undecided,
      ignoreUserPreferenceDepartmentBlacklist,
      jobInPast,
      true,
      false,
      shifts,
      search,
      transferToMe,
    );
  }

  const sort = loggedInCustomer?.prioritizeEmployeeLastName
    ? { lastName: 1 }
    : { firstName: 1 };

  return Users.find(usersQuery, { sort }).fetch() as PoolerUser[];
}
